"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmallGlobe = void 0;
const react_1 = __importDefault(require("react"));
const SmallGlobe = (_a) => {
    var { onClick } = _a, props = __rest(_a, ["onClick"]);
    return (react_1.default.createElement("svg", { onClick: onClick, width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75Z", stroke: props === null || props === void 0 ? void 0 : props.color, strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M2.25 9H15.75", stroke: props === null || props === void 0 ? void 0 : props.color, strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M9.00033 2.25C10.6887 4.09839 11.6482 6.49712 11.7004 9C11.6482 11.5029 10.6887 13.9016 9.00033 15.75C7.31194 13.9016 6.35244 11.5029 6.30029 9C6.35244 6.49712 7.31194 4.09839 9.00033 2.25V2.25Z", stroke: props === null || props === void 0 ? void 0 : props.color, strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.SmallGlobe = SmallGlobe;
